﻿import * as Backbone from 'backbone';
import * as _ from 'underscore';
import PageableCollection from 'backbone.paginator';

import config from '../../common/config';

export var Model = Backbone.Model.extend({
    constructor: function () {
        this.defaults = _.extend({}, this.defaults, {
            Pos01: -1,
            Pos02: -1,
            Pos03: -1,
            Pos04: -1,
            Pos05: -1,
            Pos06: -1,
            Pos07: -1,
            Pos08: -1,
            Pos09: -1,
            Pos10: -1,
            Pos11: -1,
            Pos12: -1,
        });

        Backbone.Model.prototype.constructor.apply(this, arguments);
    },
    errors: [],
    bust: function () {
        return this.mdUSERID + '?bust=' + new Date().getTime();
    },

    initialize: function () {
    },
    // different url for read, update
    "sync": function (method, model, options) {
        if (method == 'update') {
            options.url = config.webApiUrl() + '/api/CustomSchemaModel/' + model.attributes.id + '?AuthUserId=' + config.authUserId();
        }
        else if (method == 'create') {
            options.url = config.webApiUrl() + '/api/CustomSchemaModel/-1?AuthUserId=' + config.authUserId();
        }
        else if (method == 'delete') {
            options.url = config.webApiUrl() + '/api/CustomSchemaModel/' + model.attributes.id + '?AuthUserId=' + config.authUserId();

        }
        else {
            options.url = '';
        }

        var m = Backbone.sync(method, model, options);

        return m;
    },
    /*save: function (attributes) {
        this.options.success = this.successOnSave;
        this.options.error = this.errorOnSave;

        Backbone.Model.prototype.save.call(this, attributes, options);
    },*/
    successOnSave: function (model, response) {
        model = response;
    },
    errorOnSave: function (model, response) {
        alert("FEJL");
    },
    validateNoBackbone: function (app) {
        this.errors = [];

        //if (this.attributes.Name == "") {
        //    this.errors.push({ name: 'customSchemaModelInsert_inputName', message: resources.X100324 });
        //}

        var self = this;
        /*for (var i = 0; i < app.entities.collections.customSchemaModel.fullCollection.length; i++) {
            if ((app.entities.collections.customSchemaModel.fullCollection.models[i].attributes.id != this.attributes.id) && (this.attributes.Name == app.entities.collections.customSchemaModel.fullCollection.models[i].attributes.Name)) {
                this.errors.push({ name: 'customSchemaModelEditItem_inputName', message: resources.X100177 });
                this.errors.push({ name: 'customSchemaModelInsert_inputName', message: resources.X100177 });
            }
        };*/

        if (this.errors.length > 0) {
            return true
        }
        else {
            return false;
        }
    }
});


export var Collection = PageableCollection.extend({
    mode: "client",
    model: Model,
    
    state: {
        pageSize: 6000,
    },

    queryParams: {
        sortKey: 'id',
        order: "direction",
        directions: {
            "-1": "asc",
            "1": "desc"
        }
    },

    options: {
        full: false
    },

    "sync": function (method, model, options) {
        if (method == 'read' && (typeof options.fetchSingle !== 'undefined' && options.fetchSingle == true)) {
            options.url = config.webApiUrl() + '/api/CustomSchemaModel/fetchSingle/' + options.EventId + '?AuthUserId=' + config.authUserId();
        }
        else if (method == 'read') {
            options.url = config.webApiUrl() + '/api/CustomSchemaModel/route01/-1?AuthUserId=' + config.authUserId();
        }
        return Backbone.sync(method, model, options);
    },
    comparator: function (a, b) {
        return a.attributes.id > b.attributes.id ? -1
             : a.attributes.id < b.attributes.id ? 1
             : 0;
    }
});






